export default 'campaign-edit'
